import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import AccessGate from "../components/AccessGate";
import { useAuth } from "../context/AuthContext";

const pages = {
  stay: { type: "market", Page: lazy(() => import("../pages/StayPaymentPage")) },
  rental: { type: "market", Page: lazy(() => import("../sport/SportRentalPaymentPage")) },
  adoption: { type: "animaux", Page: lazy(() => import("../pages/AdoptionPaymentPage")) },
  funding: { type: "market", Page: lazy(() => import("../crowdfunding/FundingStripePage")) },
  support: { type: "wallet", Page: lazy(() => import("../platform-support/PlatformSupportTestPage")) },
};

export default function PrivatePaymentEntry({ kind }) {
  useSourceLanguage();
  const { user } = useAuth();
  const { paymentId, pilotId } = useParams();
  const { type, Page } = pages[kind];
  // A different account or dossier must not inherit financial data or consent.
  const identity = JSON.stringify([kind, user?.id ?? user?.username ?? null, paymentId ?? pilotId ?? null]);
  return (
    <AccessGate type={type}>
      <Suspense fallback={<p role="status"><LocalizedText source={"Chargement du dossier de paiement…"} /></p>}>
        <Page key={identity} />
      </Suspense>
    </AccessGate>
  );
}
